import { useEffect } from "react";
import { useCurrentTenant } from "@/hooks/useTenant";
import { useTheme } from "@/hooks/useTheme";
import { applyTenantTheme } from "@/lib/theme";

/**
 * Side-effect hook — fetches the broker tenant and injects its brand colour
 * onto `:root` so every component reading `--primary` picks it up. It re-runs
 * when the appearance flips, because light and dark need different action
 * colours for the same brand hue. Reverts to the packaged palette when the
 * tenant has no colour of its own.
 *
 * Mount once at the app root.
 */
export function useTenantTheme() {
  const { data } = useCurrentTenant();
  const { resolved } = useTheme();
  useEffect(() => {
    applyTenantTheme(data?.tenant?.primaryColor ?? null, resolved);
  }, [data?.tenant?.primaryColor, resolved]);
}
